import PropTypes from "prop-types"
import React from "react"

import Heading from "src/components/Heading"

const MarinaHeader = ({ marina, onCall }) => (
  <div className="flex min-w-0 items-start gap-3 border-b border-gray-300 pb-6 lg:items-center lg:gap-4">
    <img
      src={marina.image}
      alt={marina.name}
      className="h-16 w-16 shrink-0 rounded-lg object-cover lg:h-[160px] lg:w-[240px]"
    />
    <div className="flex min-w-0 flex-col space-y-1 lg:space-y-3">
      <div className="hidden lg:block">
        <Heading.HeroTitle>{marina.name}</Heading.HeroTitle>
      </div>
      <p className="truncate text-[20px] font-bold leading-tight text-gray-900 lg:hidden">
        {marina.name}
      </p>
      <div className="flex flex-col gap-1 font-semibold text-gray-700 lg:flex-row lg:flex-wrap lg:gap-x-6 lg:gap-y-1">
        {marina.address && (
          <span className="truncate text-sm">
            <i className="fa-solid fa-location-dot mr-1 text-red-500" />
            {marina.address}
          </span>
        )}
        {marina.phone && (
          <a
            href={`tel:${marina.phone}`}
            className="text-blue-600"
            onClick={onCall}
          >
            <i className="fa-solid fa-phone mr-1" />
            {marina.phone}
          </a>
        )}
      </div>
    </div>
  </div>
)

MarinaHeader.propTypes = {
  marina: PropTypes.shape({
    name: PropTypes.string.isRequired,
    address: PropTypes.string,
    phone: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  onCall: PropTypes.func,
}

export default MarinaHeader
